export const en = {
  'chat-screen-title': 'Stream chat',
  'no-data': 'No data',
}
